import { Icon, IconProps } from '@chakra-ui/react'

export default function HealthPinIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.77266 2.56504V2.56504C11.8563 4.65854 11.8563 8.04235 9.77266 10.1359V10.1359L7.56386 12.352C7.14974 12.7681 6.5869 13.002 5.99986 13.002C5.41282 13.002 4.84997 12.7681 4.43585 12.352L2.22706 10.1359C0.143404 8.04237 0.143386 4.65857 2.22702 2.56504V2.56504C3.22599 1.56134 4.58372 0.99707 5.99983 0.99707C7.41593 0.99707 8.77366 1.56134 9.77263 2.56504H9.77266Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50105 5.99888C8.50105 5.72262 8.27709 5.49867 8.00084 5.49867H7.00042V4.49826C7.00042 4.222 6.77647 3.99805 6.50021 3.99805H5.4998C5.22354 3.99805 4.99959 4.222 4.99959 4.49826V5.49867H3.99917C3.72291 5.49867 3.49896 5.72262 3.49896 5.99888V6.9993C3.49896 7.27555 3.72291 7.49951 3.99917 7.49951H4.99959V8.49992C4.99959 8.77618 5.22354 9.00013 5.4998 9.00013H6.50021C6.77647 9.00013 7.00042 8.77618 7.00042 8.49992V7.49951H8.00084C8.27709 7.49951 8.50105 7.27555 8.50105 6.9993V5.99888Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
